import {  ConfigProvider, Form } from 'antd';
import moment from 'moment';
import { DatePicker as DatePickerJalali } from "antd-jalali";
import fa_IR from "antd/lib/locale/fa_IR";

function PersianDatePicker(props) {
    const disabledDate = (current) => {
        return current < moment().startOf('day');
    }
    return (
        <div>
            <ConfigProvider locale={fa_IR} direction="tlr">
            <Form.Item name={props.name} label={props.label} labelCol={{ span: 24 }} 
                    rules={[
                        {
                            required: true,
                            message: `لطفا ${props.label} خود را وارد نمایید!`,
                        },
                    ]}
                >
                    <DatePickerJalali disabledDate={disabledDate} style={{ 'width': '100%' }} />
                </Form.Item>
            </ConfigProvider>
        </div>
    );
}

export default PersianDatePicker;
